// Máscaras de entrada para documentos

export const maskCPF = (value) => {
  const d = (value || "").replace(/\D/g, "").slice(0, 11);
  if (d.length > 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
  if (d.length > 6) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  if (d.length > 3) return `${d.slice(0, 3)}.${d.slice(3)}`;
  return d;
};

export const maskRG = (value) => {
  const d = (value || "").replace(/[^0-9xX]/g, "").slice(0, 9);
  if (d.length > 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}-${d.slice(8)}`;
  if (d.length > 5) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
  if (d.length > 2) return `${d.slice(0, 2)}.${d.slice(2)}`;
  return d;
};

export const maskCNS = (value) => {
  const d = (value || "").replace(/\D/g, "").slice(0, 16);
  return [d.slice(0, 11), d.slice(11, 15), d.slice(15, 16)]
    .filter(Boolean)
    .join(" ");
};

export const maskCEP = (value) => {
  const d = (value || "").replace(/\D/g, "").slice(0, 8);
  if (d.length > 5) return `${d.slice(0, 5)}-${d.slice(5)}`;
  return d;
};
